import { render, staticRenderFns } from "./Back-Button.vue?vue&type=template&id=8dc5f8a0&scoped=true&"
import script from "./Back-Button.vue?vue&type=script&lang=js&"
export * from "./Back-Button.vue?vue&type=script&lang=js&"
import style0 from "./Back-Button.vue?vue&type=style&index=0&id=8dc5f8a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc5f8a0",
  null
  
)

export default component.exports